import React from "react";
import { Button, Box, Grid, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

function SearchFilter({ handleSearch }) {
    const [companyName, setCompanyName] = React.useState("");
    const [mc, setMc] = React.useState("");
    const [dot, setDot] = React.useState("");


    const handleSearchEnter = (e) =>{
        if (e.keyCode == 13) {
            handleSearch(companyName, mc, dot)
        }
    }

    return (
        <>
            <Grid container style={{ padding: '1rem' }}>
                <Grid item xs={12} sm={12} md={12} lg={2} xl={2} sx={{ margin: 'auto', marginTop: '1rem' }}>
                    <Box sx={{ width: 500, maxWidth: '100%' }}>
                        <TextField fullWidth label="Search By Company Name" id="companyName"
                            value={companyName}
                            onChange={(e) => { setCompanyName(e.target.value) }}
                            onKeyDown={(e) => handleSearchEnter(e)}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={2} xl={2} sx={{ margin: 'auto', marginTop: '1rem' }}>
                    <Box sx={{ width: 500, maxWidth: '100%' }}>
                        <TextField fullWidth label="Search By MC #" id="mc"
                            value={mc}
                            onChange={(e) => { setMc(e.target.value) }}
                            onKeyDown={(e) => handleSearchEnter(e)}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={2} xl={2} sx={{ margin: 'auto', marginTop: '1rem' }}>
                    <Box sx={{ width: 500, maxWidth: '100%' }}>
                        <TextField fullWidth label="Search By DOT #" id="dot"
                            value={dot}
                            onChange={(e) => { setDot(e.target.value) }}
                            onKeyDown={(e) => handleSearchEnter(e)}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={3} xl={3} sx={{ margin: 'auto', marginTop: '1rem' }}>
                    <Button onClick={() => handleSearch(companyName, mc, dot)} sx={{ width: 250, maxWidth: '50%' }} variant="contained" endIcon={<SearchIcon />}>Search</Button>
                </Grid>
            </Grid>
        </>
    )
}

export default SearchFilter;